{
  "help": "Справка",
  "info": "Информация"
}
